var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-recaptcha",attrs:{"id":_vm.widgetId,"data-sitekey":_vm.sitekey}})}
var staticRenderFns = []

export { render, staticRenderFns }